module.exports = "/packs/media/images/logo-troweprice-33749d811dbc8b90a2ac28a2975f6c69.png";